"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.getUnauthenticatedBaseUrl = exports.tryToGetUploadConfig = void 0;
var getScaToken_1 = require("../auth/getScaToken");
var ssoClientConfig_1 = require("../auth/ssoClientConfig");
var constants_1 = require("./constants");
var authState_1 = require("../auth/authState");
var environment_1 = require("../environment");
var initBlizzard_1 = require("../initBlizzard");
var logger_1 = require("../logger");
var config_1 = require("../config");
function tryToGetUploadConfig(refresh) {
    return __awaiter(this, void 0, void 0, function () {
        var uploadConfig, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, getUploadConfig(refresh)];
                case 1:
                    uploadConfig = _a.sent();
                    return [3, 3];
                case 2:
                    e_1 = _a.sent();
                    log.error("Failed to get upload config: ", e_1);
                    uploadConfig = undefined;
                    return [3, 3];
                case 3: return [2, uploadConfig];
            }
        });
    });
}
exports.tryToGetUploadConfig = tryToGetUploadConfig;
function getUploadConfig(refresh) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var authState, ssoClientId, isAuthEnabled, authorizationHeader, _b, _c, baseUrl;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4, (0, authState_1.getAuthState)()];
                case 1:
                    authState = _d.sent();
                    ssoClientId = (0, authState_1.getSsoClientId)();
                    isAuthEnabled = ssoClientId && authState.ssoToken && authState.authStatus === authState_1.AuthStatus.AUTHENTICATED;
                    if (refresh && isAuthEnabled) {
                        log.info("SSO tokens cannot be refreshed - if provider does not provide a new one asynchronously this may be an issue with the provider");
                        return [2, refresh];
                    }
                    if (!isAuthEnabled) return [3, 2];
                    _b = "Bearer ".concat(authState.ssoToken);
                    return [3, 4];
                case 2:
                    _c = "SCA ".concat;
                    return [4, (0, getScaToken_1.getScaToken)(Boolean(refresh))];
                case 3:
                    _b = _c.apply("SCA ", [_d.sent()]);
                    _d.label = 4;
                case 4:
                    authorizationHeader = _b;
                    return [4, (0, config_1.customBaseUrl)()];
                case 5:
                    baseUrl = (_a = (_d.sent())) !== null && _a !== void 0 ? _a : (isAuthEnabled ? (0, ssoClientConfig_1.getAuthBaseUrl)(ssoClientId) : getUnauthenticatedBaseUrl());
                    return [2, {
                            baseUrl: baseUrl,
                            credentials: isAuthEnabled ? "include" : "same-origin",
                            authorizationHeader: authorizationHeader
                        }];
            }
        });
    });
}
function getUnauthenticatedBaseUrl() {
    return (0, environment_1.getCollectionMode)() === initBlizzard_1.CollectionMode.STAGE ? constants_1.DEFAULT_BASE_URL_STAGING : constants_1.DEFAULT_BASE_URL;
}
exports.getUnauthenticatedBaseUrl = getUnauthenticatedBaseUrl;
var log = (0, logger_1.getLogger)("uploadConfig");
//# sourceMappingURL=getUploadConfig.js.map